/** 9.2c-2 app-auth state. cookie 是 source of truth;不持久化,刷新靠 /me bootstrap。 */
import { create } from 'zustand';

export type AuthStatus = 'idle' | 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthUser {
  username: string;
  role: string;
  must_change_password: boolean;
}

interface AuthState {
  user: AuthUser | null;
  status: AuthStatus;
  setUser: (user: AuthUser | null) => void;
  setStatus: (status: AuthStatus) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  setUser: (user) => set({ user, status: user ? 'authenticated' : 'unauthenticated' }),
  setStatus: (status) => set({ status }),
  clearAuth: () => set({ user: null, status: 'unauthenticated' }),
}));

// Selectors（避免 component subscribe 全 state）
export const selectIsAuthenticated = (s: AuthState): boolean =>
  s.status === 'authenticated' && s.user !== null;
export const selectMustChangePassword = (s: AuthState): boolean =>
  s.user?.must_change_password === true;
